







































import { Component, Prop, Vue } from "vue-property-decorator";

import InputSearch from "../../app/search/input-search.vue";
import ButtonBack from "@/components/buttons/button-back.vue";

@Component({ components: { InputSearch, back: ButtonBack } })
export default class ChannelListHeader extends Vue {
  @Prop({ type: Boolean, default: false }) deleted!: boolean;
  @Prop({ type: String, default: "" }) sortKey!: string;
}
